import { render } from "./haproxy-config.vue?vue&type=template&id=b0bb1c4c&scoped=true"
import script from "./haproxy-config.vue?vue&type=script&lang=js"
export * from "./haproxy-config.vue?vue&type=script&lang=js"

import "./haproxy-config.vue?vue&type=style&index=0&id=b0bb1c4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0bb1c4c"]])

export default __exports__